import {configureStore} from '@reduxjs/toolkit';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './rootReducer';
// import {thunk} from 'redux-thunk';
// import { logger } from 'redux-logger';

const persistConfig = {
  key: 'tecnogexadmin',
  storage,

  // cart will be removed from this list after the cart is implemented
  // blacklist: ['user'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  // .concat(thunk), //, logger
});

const persistor = persistStore(store);

export {store, persistor};

// import { configureStore } from '@reduxjs/toolkit';
// import { persistStore } from 'redux-persist';
// import rootReducer from './rootReducer';

// const store = configureStore({
//   reducer: rootReducer,
//   middleware: getDefaultMiddleware =>
//     getDefaultMiddleware({
//       serializableCheck: false,
//     }),
// });

// const persistor = persistStore(store);

// export { store, persistor };
